'use client';

import dynamic from 'next/dynamic';
import { TPrintButtonProps } from './index';

export const DynamicPrintButton = dynamic<TPrintButtonProps>(
  () => import('./index').then((mod) => mod.PrintButton),
  {
    ssr: false,
  },
);
